import * as React from 'react';
import { cn } from '../cn';

export interface DescriptionItem {
  label: React.ReactNode;
  value: React.ReactNode;
  /** span both columns */
  wide?: boolean;
}
export function DescriptionList({ items, className, columns = 2 }: { items: DescriptionItem[]; className?: string; columns?: 1 | 2 | 3 }) {
  return (
    <dl className={cn('grid gap-x-8 gap-y-3', columns === 2 ? 'sm:grid-cols-2' : columns === 3 ? 'sm:grid-cols-3' : 'grid-cols-1', className)}>
      {items.map((it, i) => (
        <div key={i} className={cn('min-w-0', it.wide && 'sm:col-span-full')}>
          <dt className="text-[12px] font-medium text-text-3">{it.label}</dt>
          <dd className="mt-0.5 text-[14px] text-text break-words [&:empty]:before:content-['—'] [&:empty]:before:text-text-3">{it.value ?? <span className="text-text-3">—</span>}</dd>
        </div>
      ))}
    </dl>
  );
}

/** Row list with hairlines (Settings-style grouped list). */
export function ListGroup({ children, className, title }: { children: React.ReactNode; className?: string; title?: React.ReactNode }) {
  return (
    <div className={className}>
      {title ? <div className="px-1 pb-1.5 text-[12px] font-medium uppercase tracking-[0.06em] text-text-3">{title}</div> : null}
      <div className="bg-surface rounded-[var(--radius-lg)] shadow-[var(--shadow-sm)] overflow-hidden divide-y divide-[var(--separator)]">{children}</div>
    </div>
  );
}
export function ListRow({ label, description, children, className, leading }: { label: React.ReactNode; description?: React.ReactNode; children?: React.ReactNode; className?: string; leading?: React.ReactNode }) {
  return (
    <div className={cn('flex items-center gap-4 px-4 py-3 min-h-[52px]', className)}>
      {leading ? <span className="shrink-0 text-text-2 [&>svg]:size-[18px]">{leading}</span> : null}
      <div className="min-w-0 flex-1">
        <div className="text-[14px] text-text">{label}</div>
        {description ? <div className="text-[12.5px] text-text-2 mt-0.5">{description}</div> : null}
      </div>
      {children ? <div className="shrink-0 flex items-center gap-2">{children}</div> : null}
    </div>
  );
}
